import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Section } from '../ui/Section';
import { Button } from '../ui/Button';
import { ArrowRight, Send } from 'lucide-react';
export function CTASection() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });
  const [submitted, setSubmitted] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    await new Promise(resolve => setTimeout(resolve, 1200));
    setIsSubmitting(false);
    setSubmitted(true);
  };
  return <Section id="cta" background="dark" data-id="element-84">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-85">
        {/* Left: Headline */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-86">
          <h2 className="text-4xl md:text-5xl font-bold font-heading text-white mb-6 leading-tight" data-id="element-87">
            Let's Build Something Meaningful
          </h2>
          <p className="text-xl text-blue-200 mb-8 leading-relaxed" data-id="element-88">
            Have a project in mind or need guidance on your digital direction?
            Tell us about it — we'll get back to you within 24 hours.
          </p>
          <div className="space-y-4 text-blue-200 text-sm" data-id="element-89">
            <div className="flex items-center gap-3" data-id="element-90">
              <span className="w-2 h-2 rounded-full bg-[#FF6600] shrink-0" data-id="element-91" />
              <span data-id="element-92">
                Strategy, design, and development — all under one roof
              </span>
            </div>
            <div className="flex items-center gap-3" data-id="element-93">
              <span className="w-2 h-2 rounded-full bg-[#FF6600] shrink-0" data-id="element-94" />
              <span data-id="element-95">Transparent process, clear timelines</span>
            </div>
            <div className="flex items-center gap-3" data-id="element-96">
              <span className="w-2 h-2 rounded-full bg-[#FF6600] shrink-0" data-id="element-97" />
              <span data-id="element-98">Long-term partnership, not just delivery</span>
            </div>
          </div>
        </motion.div>

        {/* Right: Form */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.15
      }} data-id="element-99">
          {submitted ? <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} className="bg-white/10 backdrop-blur-sm rounded-2xl p-10 text-center border border-white/20" data-id="element-100">
              <div className="w-16 h-16 rounded-full bg-[#FF6600] flex items-center justify-center mx-auto mb-6" data-id="element-101">
                <Send className="w-7 h-7 text-white" data-id="element-102" />
              </div>
              <h3 className="text-2xl font-bold font-heading text-white mb-3" data-id="element-103">
                Message Sent!
              </h3>
              <p className="text-blue-200" data-id="element-104">
                Thanks for reaching out. We'll be in touch within 24 hours.
              </p>
            </motion.div> : <form onSubmit={handleSubmit} className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 border border-white/20 space-y-5" data-id="element-105">
              <div data-id="element-106">
                <label className="block text-sm font-medium text-blue-100 mb-2" data-id="element-107">
                  Your Name
                </label>
                <input type="text" name="name" required value={formData.name} onChange={handleChange} placeholder="John Doe" className="w-full px-4 py-3 bg-white/10 border border-white/20 rounded-lg text-white placeholder-blue-300 focus:outline-none focus:ring-2 focus:ring-[#FF6600]/50 focus:border-[#FF6600] transition-colors" data-id="element-108" />
              </div>
              <div data-id="element-109">
                <label className="block text-sm font-medium text-blue-100 mb-2" data-id="element-110">
                  Email Address
                </label>
                <input type="email" name="email" required value={formData.email} onChange={handleChange} placeholder="john@company.com" className="w-full px-4 py-3 bg-white/10 border border-white/20 rounded-lg text-white placeholder-blue-300 focus:outline-none focus:ring-2 focus:ring-[#FF6600]/50 focus:border-[#FF6600] transition-colors" data-id="element-111" />
              </div>
              <div data-id="element-112">
                <label className="block text-sm font-medium text-blue-100 mb-2" data-id="element-113">
                  Tell us about your project
                </label>
                <textarea name="message" required rows={4} value={formData.message} onChange={handleChange} placeholder="Describe your goals, timeline, and any details..." className="w-full px-4 py-3 bg-white/10 border border-white/20 rounded-lg text-white placeholder-blue-300 focus:outline-none focus:ring-2 focus:ring-[#FF6600]/50 focus:border-[#FF6600] transition-colors resize-none" data-id="element-114" />
              </div>
              <Button type="submit" size="lg" isLoading={isSubmitting} className="w-full bg-[#FF6600] text-white hover:bg-[#CC5200]" rightIcon={<ArrowRight className="w-5 h-5" data-id="element-116" />} data-id="element-115">
                Send Message
              </Button>
            </form>}
        </motion.div>
      </div>
    </Section>;
}